import { css } from '@emotion/css'

export const container = css`
  width: 100%;
`